<!--<div>-->
<!--    <mat-icon>{{(tag.id === null) ? "search" : "label"}}</mat-icon>-->
<!--    <span (click)="clickHandler($event)">{{tag.displayName}}</span>-->
<!--    <button mat-button matSuffix mat-icon-button aria-label="Clear" (click)="closeHandler($event)">-->
<!--        <mat-icon>close</mat-icon>-->
<!--    </button>-->
<!--</div>-->

<mat-chip-option [removable]="true" (removed)="closeHandler($event)">{{
    tag.displayName
}}</mat-chip-option>
